module.exports = __webpack_public_path__ + "img/yy.366a5033.gif";